import { render } from "./QuanTriBaiViet.vue?vue&type=template&id=206a9da2&scoped=true"
import script from "./QuanTriBaiViet.vue?vue&type=script&lang=js"
export * from "./QuanTriBaiViet.vue?vue&type=script&lang=js"

import "./QuanTriBaiViet.vue?vue&type=style&index=0&id=206a9da2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206a9da2"]])

export default __exports__